// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trasfer-histroy-wrapper {
    /* padding-top: 80px; */
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    background-attachment: fixed;
    /* height: 100vh; */
  }
  
  .fiter-dropdown-mobile {
    display: none;
  }
  
  .transfer-history-header {
    display: flex;
    align-items: center;
    text-align: left;
    padding-top: 16px;
    border-bottom: 1px solid #85858545;
    padding-bottom: 16px;
  }
  
  .transfer-history-header img {
    width: 65px;
  }
  
  .search-icon img {
    width: 20px;
}

  .transfer-history-header h3 {
    font-size: 40px;
    color: #383838;
    margin: 0px;
  }
  
  .tranfer-history-dropdown-wrapper {
    margin-top: 50px;
  }
  
  .filter-select-wraper {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    margin-top: 20px;
    gap: 25px;
  }
  
  .date-filter {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .date-filter select {
    padding: 10px 10px;
    border: 1px solid var(--buttonColor);
    border-radius: 5px;
    outline: none;
    color: #383838;
    font-size: 18px;
    font-weight: 400;
  }
  
  .date-filter h3 {
    font-size: 21px;
    margin: 0px;
    color: #383838;
  }
  
  table.dataTable.table-striped > tbody > tr.odd > *,
  table.dataTable.table-striped > tbody > tr.even > * {
    box-shadow: unset;
    border-left: 1px solid #ccc;
    color: #717171 !important;
    font-size: 18px;
  }
  
  table.dataTable thead > tr > th.sorting,
  table.dataTable thead > tr > th.sorting_asc,
  table.dataTable thead > tr > th.sorting_desc {
    text-align: center;
    font-size: 20px;
    color: #383838;
  }
  
  table.dataTable.table-striped > tbody > tr:nth-of-type(2n + 1) > * {
    box-shadow: none;
    color: #717171 !important;
  }
  
  
  .transation-icon-wrap {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  
  .payment-sent-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }
  
  .simplex-platform-status-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .simplex-platform-status-wrap p{
    font-size: 18px;
    font-weight: 400;
    color: #717171;
    margin: 0px;
  } 
  
  .simplex-platform-status-wrap img{
    width: 18px;
    height: 18px;
  }
  
  .fiat-amount-td-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  
  
  table.table.table-striped thead, tr, td {
    position: relative;
  }
  
  .table-icon-info {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  
  .symplex-icon-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }
  
  .fiat-amount-td-wrap img {
    width: 35px;
  }
  
  .transfer-admin-history-wrap{
    margin-left: 150px;
  }
  
  
  .fiat-amount-td-wrap p {
    min-width: 100px;
    margin: 0px;
  }
  
  
  .invoice-price-wrap p{
    min-width: 100px;
    margin: 0px;
  }
  
  .invoice-price-wrap {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  
  
  
  .tranfer-history-dropdown-wrapper .table > tbody {
    border-left: unset;
    border-right: unset;
    /* border-top: unset !important; */
  }
  
  .tranfer-history-dropdown-wrapper  table tr td{
    border-left: unset !important;
  }
  
  
  
  @media (max-width: 768px) {
    .fiter-dropdown {
      display: none;
    }
    .fiter-dropdown-mobile {
      width: 170px;
      margin-top: 40px;
  
      display: block;
    }
  
    .mobile-filter-wrap {
      margin-top: 20px;
      padding: 15px 10px;
      border: 1px solid var(--buttonColor);
      border-radius: 5px;
      outline: none;
      color: #383838;
      font-size: 16px;
      font-weight: 300;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      cursor: pointer;
    }
  
    .mobile-filter-wrap img {
      width: 18px;
      height: 18px;
    }
  
    .mobile-filter-wrap h3 {
      margin: 0px;
      font-size: 18px;
    }

    table.dataTable.table-striped > tbody > tr.odd > *,
    table.dataTable.table-striped > tbody > tr.even > * {
      box-shadow: unset;
      border-left: 1px solid #ccc;
      color: #383838;
      font-size: 22px;
    }
  
    table.dataTable thead > tr > th.sorting,
    table.dataTable thead > tr > th.sorting_asc,
    table.dataTable thead > tr > th.sorting_desc {
      text-align: center;
      font-size: 24px;
      color: #383838;
    }
  
    table.dataTable.table-striped > tbody > tr:nth-of-type(2n + 1) > * {
      box-shadow: none;
      color: #383838 !important;
    }
  }
  
  
  @media(min-width: 1025px) and (max-width: 1599px){
    .transfer-history-header h3 {
      font-size: 30px;
      margin: 0px;
    }
  }
  
  @media (min-width: 1600px) {
    .tranfer-history-dropdown-wrapper.table-responsive{
      overflow-x: unset !important;
    }
  
    .table-responsive{
      overflow-x: unset !important;
    }
  
    
    .date-filter h3 {
      font-size: 20px;
      margin: 0px;
      color: #383838;
    }
  
    .filter-select-wraper {
      margin-top: 50px;
    }
  
    .transfer-history-header h3 {
      font-size: 35px;
      padding: 10px;
  }
  
  .fiat-amount-td-wrap p {
    min-width: 100px;
    margin: 0px;
  }
  
  }
  /* 
  li,
  a {
    transition: background 0.35s ease;
  }
  
  * {
    box-sizing: border-box;
  }
  
  html,
  body {
    width: 100%;
    height: 100%;
  }
  
  h1 {
    font-size: 1.2em;
  }
  
  li {
    font-size: 1em;
  }
  
  .dropdown {
    margin: 2em auto;
    width: 14.5em;
    border: 1px solid var(--buttonColor);
  }
  
  .custom-dropdown {
    position: absolute;
    background-color: #fff4d5;
    width: 220px;
  }
  
  a {
    display: block;
    padding: 0.5em;
    color: #000;
    text-decoration: none;
  }
  a:focus,
  a:hover {
    background: #ecf0f1;
  }
  a:active {
    background: #fbfcfc;
  }
  
  .fa {
    float: right;
  }
  
  ul {
    display: none;
  }
  
  li {
    padding: 0.5em;
    cursor: pointer;
    list-style: none;
  } */
  /* li:not(:first-child) {
    border-top: 0.1em dashed #dde4e6;
  } */
  
  /* li:focus,
  li:hover {
    background: #fbc425;
  }
  li:active {
    background: #fbc425;
  }
  
  ul.js-dropdown-list {
    padding: unset;
  } */
  
  @media (min-width: 1920px) {
    .transfer-history-header h3 {
      font-size: 38px;
      margin-bottom: 0px;
    }
  
    .date-filter h3 {
      font-size: 23px;
    }
    .date-filter select {
      padding: 12px 30px 12px 12px;
    }
  
    table.dataTable thead > tr > th.sorting,
    table.dataTable thead > tr > th.sorting_asc,
    table.dataTable thead > tr > th.sorting_desc {
      text-align: center;
      font-size: 21px;
      color: #383838;
    }
  }

  
  .tranfer-history-dropdown-wrapper div#transfer_length, div#transfer_filter {
    display: none;
  }
  
  
  
  `, "",{"version":3,"sources":["webpack://./src/Dashboard/Transaction/Transfer.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,uCAAuC;IACvC,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;AACf;;EAEE;IACE,eAAe;IACf,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;;IAEE,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;;EAGA;IACE,gBAAgB;IAChB,WAAW;EACb;;;EAGA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;;;EAIA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;EAC/B;;;;EAIA;IACE;MACE,aAAa;IACf;IACA;MACE,YAAY;MACZ,gBAAgB;;MAEhB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,oCAAoC;MACpC,kBAAkB;MAClB,aAAa;MACb,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;;MAEE,iBAAiB;MACjB,2BAA2B;MAC3B,cAAc;MACd,eAAe;IACjB;;IAEA;;;MAGE,kBAAkB;MAClB,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,yBAAyB;IAC3B;EACF;;;EAGA;IACE;MACE,eAAe;MACf,WAAW;IACb;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,4BAA4B;IAC9B;;;IAGA;MACE,eAAe;MACf,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,aAAa;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA8DG;EACH;;KAEG;;EAEH;;;;;;;;;;KAUG;;EAEH;IACE;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,4BAA4B;IAC9B;;IAEA;;;MAGE,kBAAkB;MAClB,eAAe;MACf,cAAc;IAChB;EACF;;;EAGA;IACE,aAAa;EACf","sourcesContent":[".trasfer-histroy-wrapper {\n    /* padding-top: 80px; */\n    background-size: 100% 100% !important;\n    background-repeat: no-repeat !important;\n    background-attachment: fixed;\n    /* height: 100vh; */\n  }\n  \n  .fiter-dropdown-mobile {\n    display: none;\n  }\n  \n  .transfer-history-header {\n    display: flex;\n    align-items: center;\n    text-align: left;\n    padding-top: 16px;\n    border-bottom: 1px solid #85858545;\n    padding-bottom: 16px;\n  }\n  \n  .transfer-history-header img {\n    width: 65px;\n  }\n  \n  .search-icon img {\n    width: 20px;\n}\n\n  .transfer-history-header h3 {\n    font-size: 40px;\n    color: #383838;\n    margin: 0px;\n  }\n  \n  .tranfer-history-dropdown-wrapper {\n    margin-top: 50px;\n  }\n  \n  .filter-select-wraper {\n    display: flex;\n    /* justify-content: center; */\n    align-items: center;\n    margin-top: 20px;\n    gap: 25px;\n  }\n  \n  .date-filter {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .date-filter select {\n    padding: 10px 10px;\n    border: 1px solid var(--buttonColor);\n    border-radius: 5px;\n    outline: none;\n    color: #383838;\n    font-size: 18px;\n    font-weight: 400;\n  }\n  \n  .date-filter h3 {\n    font-size: 21px;\n    margin: 0px;\n    color: #383838;\n  }\n  \n  table.dataTable.table-striped > tbody > tr.odd > *,\n  table.dataTable.table-striped > tbody > tr.even > * {\n    box-shadow: unset;\n    border-left: 1px solid #ccc;\n    color: #717171 !important;\n    font-size: 18px;\n  }\n  \n  table.dataTable thead > tr > th.sorting,\n  table.dataTable thead > tr > th.sorting_asc,\n  table.dataTable thead > tr > th.sorting_desc {\n    text-align: center;\n    font-size: 20px;\n    color: #383838;\n  }\n  \n  table.dataTable.table-striped > tbody > tr:nth-of-type(2n + 1) > * {\n    box-shadow: none;\n    color: #717171 !important;\n  }\n  \n  \n  .transation-icon-wrap {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n  }\n  \n  \n  .payment-sent-icon-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n  }\n  \n  .simplex-platform-status-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .simplex-platform-status-wrap p{\n    font-size: 18px;\n    font-weight: 400;\n    color: #717171;\n    margin: 0px;\n  } \n  \n  .simplex-platform-status-wrap img{\n    width: 18px;\n    height: 18px;\n  }\n  \n  .fiat-amount-td-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n  }\n  \n  \n  table.table.table-striped thead, tr, td {\n    position: relative;\n  }\n  \n  .table-icon-info {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    cursor: pointer;\n  }\n  \n  .symplex-icon-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n  }\n  \n  .fiat-amount-td-wrap img {\n    width: 35px;\n  }\n  \n  .transfer-admin-history-wrap{\n    margin-left: 150px;\n  }\n  \n  \n  .fiat-amount-td-wrap p {\n    min-width: 100px;\n    margin: 0px;\n  }\n  \n  \n  .invoice-price-wrap p{\n    min-width: 100px;\n    margin: 0px;\n  }\n  \n  .invoice-price-wrap {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n  }\n  \n  \n  \n  .tranfer-history-dropdown-wrapper .table > tbody {\n    border-left: unset;\n    border-right: unset;\n    /* border-top: unset !important; */\n  }\n  \n  .tranfer-history-dropdown-wrapper  table tr td{\n    border-left: unset !important;\n  }\n  \n  \n  \n  @media (max-width: 768px) {\n    .fiter-dropdown {\n      display: none;\n    }\n    .fiter-dropdown-mobile {\n      width: 170px;\n      margin-top: 40px;\n  \n      display: block;\n    }\n  \n    .mobile-filter-wrap {\n      margin-top: 20px;\n      padding: 15px 10px;\n      border: 1px solid var(--buttonColor);\n      border-radius: 5px;\n      outline: none;\n      color: #383838;\n      font-size: 16px;\n      font-weight: 300;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 20px;\n      cursor: pointer;\n    }\n  \n    .mobile-filter-wrap img {\n      width: 18px;\n      height: 18px;\n    }\n  \n    .mobile-filter-wrap h3 {\n      margin: 0px;\n      font-size: 18px;\n    }\n\n    table.dataTable.table-striped > tbody > tr.odd > *,\n    table.dataTable.table-striped > tbody > tr.even > * {\n      box-shadow: unset;\n      border-left: 1px solid #ccc;\n      color: #383838;\n      font-size: 22px;\n    }\n  \n    table.dataTable thead > tr > th.sorting,\n    table.dataTable thead > tr > th.sorting_asc,\n    table.dataTable thead > tr > th.sorting_desc {\n      text-align: center;\n      font-size: 24px;\n      color: #383838;\n    }\n  \n    table.dataTable.table-striped > tbody > tr:nth-of-type(2n + 1) > * {\n      box-shadow: none;\n      color: #383838 !important;\n    }\n  }\n  \n  \n  @media(min-width: 1025px) and (max-width: 1599px){\n    .transfer-history-header h3 {\n      font-size: 30px;\n      margin: 0px;\n    }\n  }\n  \n  @media (min-width: 1600px) {\n    .tranfer-history-dropdown-wrapper.table-responsive{\n      overflow-x: unset !important;\n    }\n  \n    .table-responsive{\n      overflow-x: unset !important;\n    }\n  \n    \n    .date-filter h3 {\n      font-size: 20px;\n      margin: 0px;\n      color: #383838;\n    }\n  \n    .filter-select-wraper {\n      margin-top: 50px;\n    }\n  \n    .transfer-history-header h3 {\n      font-size: 35px;\n      padding: 10px;\n  }\n  \n  .fiat-amount-td-wrap p {\n    min-width: 100px;\n    margin: 0px;\n  }\n  \n  }\n  /* \n  li,\n  a {\n    transition: background 0.35s ease;\n  }\n  \n  * {\n    box-sizing: border-box;\n  }\n  \n  html,\n  body {\n    width: 100%;\n    height: 100%;\n  }\n  \n  h1 {\n    font-size: 1.2em;\n  }\n  \n  li {\n    font-size: 1em;\n  }\n  \n  .dropdown {\n    margin: 2em auto;\n    width: 14.5em;\n    border: 1px solid var(--buttonColor);\n  }\n  \n  .custom-dropdown {\n    position: absolute;\n    background-color: #fff4d5;\n    width: 220px;\n  }\n  \n  a {\n    display: block;\n    padding: 0.5em;\n    color: #000;\n    text-decoration: none;\n  }\n  a:focus,\n  a:hover {\n    background: #ecf0f1;\n  }\n  a:active {\n    background: #fbfcfc;\n  }\n  \n  .fa {\n    float: right;\n  }\n  \n  ul {\n    display: none;\n  }\n  \n  li {\n    padding: 0.5em;\n    cursor: pointer;\n    list-style: none;\n  } */\n  /* li:not(:first-child) {\n    border-top: 0.1em dashed #dde4e6;\n  } */\n  \n  /* li:focus,\n  li:hover {\n    background: #fbc425;\n  }\n  li:active {\n    background: #fbc425;\n  }\n  \n  ul.js-dropdown-list {\n    padding: unset;\n  } */\n  \n  @media (min-width: 1920px) {\n    .transfer-history-header h3 {\n      font-size: 38px;\n      margin-bottom: 0px;\n    }\n  \n    .date-filter h3 {\n      font-size: 23px;\n    }\n    .date-filter select {\n      padding: 12px 30px 12px 12px;\n    }\n  \n    table.dataTable thead > tr > th.sorting,\n    table.dataTable thead > tr > th.sorting_asc,\n    table.dataTable thead > tr > th.sorting_desc {\n      text-align: center;\n      font-size: 21px;\n      color: #383838;\n    }\n  }\n\n  \n  .tranfer-history-dropdown-wrapper div#transfer_length, div#transfer_filter {\n    display: none;\n  }\n  \n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
